
export default function roles() {
    const Admin = {
        "dashboard": 1,
        "reports": 2,
        "adminRead": 3,
        "adminWrite": 4,
        "companyDeployRead": 5,
        "companyDeployWrite": 6,
        "tripCopy": 7,
    };
    const Owner = {
        "ownerDashboard": 51,
        "ownerReports": 52,
        "ownerCompanySetupRead": 53,
        "ownerCompanySetupWrite": 54,
        "ownerTripRead": 55,
        "ownerTripWrite": 56,
        "ownerRead": 57,
        "ownerWrite": 58,
        "agentBalanceRecharge": 59,
        "agentBalanceHistory": 60,
        "tripCopy": 61,
    };
    const Counterman = {
        "ticketBooking": 101,
        "fareDiscount": 102,
        "reports": 103,
        "trips": 104,
        "coach": 105,
        "fares": 106,
        "ticketCancel": 107,
        "cancelOthersTicket": 108,
        "extraTicketBooking": 109,
        "goodsTicketBooking": 110,
        "tripPass": 111,
        "tripEdit": 112,
        "reservation": 113,
        "cancelReservation": 114,
        "cancelOtherReservation": 115,
    };
    const Agent = {
        "ticketBooking": 151,
        "fareDiscount": 152,
        "reports": 153,
        "trips": 154,
        "coach": 155,
        "fares": 156,
        "ticketCancel": 157,
        "extraTicketBooking": 158,
        "goodsTicketBooking": 159,
        "tripPass": 160,
        "tripEdit": 161,
        "cancelOthersTicket": 162,
    };
    return {
        Admin,Owner,Counterman,Agent
    };
}
//1-49 for Admin
//50-99 for owner
//100-149 for counterman